module.exports = __webpack_public_path__ + "img/IO.1ad24c62.png";